import { render } from "./ExamCard.vue?vue&type=template&id=de54465e&scoped=true"
import script from "./ExamCard.vue?vue&type=script&lang=js"
export * from "./ExamCard.vue?vue&type=script&lang=js"

import "./ExamCard.vue?vue&type=style&index=0&id=de54465e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de54465e"]])

export default __exports__